/**
 * @module explore/components/creatives
 */
import React, { Component, PropTypes } from 'react';
import CreativesPage from 'explore/components/creatives_page';
import ExploreCTA from 'explore/components/explore_cta';
import { LoadingIndicator } from 'common/components/preloader';
import { getCanonicalURL, hasAPIQueryStringChanged } from 'common/utils';
import InviteModal from 'invite/containers/modal';
import Pager from 'common/pager/containers';
import { Meta } from 'common/components/meta';
import {
  trackMixpanel, MP_VIEWED_MARKETING_PAGE_EVENT_NAME,
  MP_CLICKED_GET_STARTED_EVENT_NAME, MP_CLICKED_HOW_IT_WORKS_EVENT_NAME,
  MP_CLICKED_WORK_1_TO_1_EVENT_NAME
} from 'common/tracking';
import { CREATIVES_RESOURCE_NAME } from 'explore/constants';
import CreativesControls from 'explore/containers/creatives_controls';
import AppliedFilters from 'explore/containers/creatives_applied_filters';

/**
 * Main component for the explore creatives
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class ExploreCreatives extends Component {
  componentDidMount() {
    this.props.fetchCreatives();
    trackMixpanel(
      MP_VIEWED_MARKETING_PAGE_EVENT_NAME,
      {
        "pageName": "Explore"
      }
    )
    trackMixpanel("Viewed explore", {"group": "Creatives"});
  }

  componentDidUpdate(prevProps) {
    /* re-fetch resource if filter/sorting/search/etc query parameters have changed */
    if (hasAPIQueryStringChanged(CREATIVES_RESOURCE_NAME, prevProps, this.props)) {
      this.props.fetchCreatives();
    }
  }

  renderCreatives() {
    const { user } = this.props;
    return (
      <CreativesPage
        fetching={this.props.creativesFetching}
        creatives={this.props.creativesState.data}
        user={this.props.user}
      />
    );
  }

  renderCTA() {
    const { user } = this.props;

    if (!user.logged_in) {
      return <ExploreCTA
        anonymous={true}
        getStartedEventTracking={{
          eventName: MP_CLICKED_WORK_1_TO_1_EVENT_NAME,
          eventData: {
            pageName: "Creative explorer",
            pageArea: "CTA",
          }
        }}
        howItWorksEventTracking={{
          eventName: MP_CLICKED_HOW_IT_WORKS_EVENT_NAME,
          eventData: {
            pageName: "Creative explorer",
            pageArea: "CTA",
          }
        }}
      />;
    } else if (user.profile_data.user_type !== 'creative') {
      return <ExploreCTA
        getStartedEventTracking={{
          eventName: MP_CLICKED_WORK_1_TO_1_EVENT_NAME,
          eventData: {
            pageName: "Creative explorer",
            pageArea: "CTA",
          }
        }}
        howItWorksEventTracking={{
          eventName: MP_CLICKED_HOW_IT_WORKS_EVENT_NAME,
          eventData: {
            pageName: "Creative explorer",
            pageArea: "CTA",
          }
        }}
        />;
    }

    return null;
  }

  render() {
    const { creativesState, user } = this.props;
    const isClient = user && user.profile_data.is_client;

    return (
      <div className="explore-page">
        <Meta
          title="Creatives | Explore | crowdspring"
          meta={[
            { property: 'og:title', content: "crowdspring creatives" },
            { property: 'og:url', content: getCanonicalURL("/explore/creatives/") },
          ]}
          link={[{ rel: 'canonical', href: getCanonicalURL('/explore/creatives/') }]}
        />
        { this.renderCTA() }
        <div className="row">
          <div className="small-16 column explore-results">
            <div className="row">
              <div className="columns small-16 large-12">
                <AppliedFilters />
              </div>
            </div>

            <div className="row">
              { this.renderCreatives() }

              <div className="show-for-large medium-4 columns">
                <CreativesControls />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="columns medium-12">
            <Pager resourceName={CREATIVES_RESOURCE_NAME} />
          </div>
        </div>
        { isClient && <InviteModal /> }
      </div>
    );
  }
}

ExploreCreatives.propTypes = {
  creativesState: PropTypes.object,
  creativesFetching: PropTypes.bool,
  user: PropTypes.shape({
    logged_in: PropTypes.bool,
  }),
  fetchCreatives: PropTypes.func,
};



// WEBPACK FOOTER //
// ./explore/components/creatives.jsx